<script setup lang="ts">
const { getAllFormations } = useFormations()
const formations = await getAllFormations()

const { setPageSeo } = useSeo()

await setPageSeo({
  title: 'Formations Game Art et Game Dev',
  description: 'Bachelor Game Artist et Bachelor Game Developer à Narbonne : deux cursus métiers du jeu vidéo pour transformer votre passion en savoir-faire professionnel.'
})
</script>

<template>
  <div class="bg-background text-foreground min-h-screen transition-colors duration-300">
    <UiPageHero 
      pageKey="formations"
      badge-text="Cursus & Programmes"
      title-prefix="DEUX CURSUS"
      title-highlight="MÉTIERS"
      description="Un apprentissage concret pour transformer votre passion en un véritable savoir-faire professionnel."
      :tags="['CURSUS ART', 'CURSUS DEV']"
      height="screen"
      align="left"
      :primary-button="{ text: 'CANDIDATER', to: '/candidature', umamiEvent: 'Formations - Hero - Candidater' }"
      :secondary-button="{ text: 'VOIR LES RÉALISATIONS', to: '/projets', umamiEvent: 'Formations - Hero - Projets' }"
    />


    <section class="container mx-auto px-6 py-16" aria-label="Liste des formations">
      <ul class="flex flex-row flex-wrap justify-center items-center gap-12 list-none p-0">
        <li v-for="formation in formations" :key="formation.slug" class="w-[450px] max-w-full flex-none">
          <NuxtLink 
            :to="`/formations/${formation.slug}`"
            class="group block relative bg-oxo-card-bg rounded-2xl overflow-hidden border border-oxo-border hover:-translate-y-2 transition-all duration-500 shadow-lg hover:shadow-xl dark:shadow-none h-full"
          >
            <article class="flex flex-col h-full">
              <div class="h-64 overflow-hidden relative">
                <NuxtImg loading="lazy"
                  :src="formation.image"
                  :alt="formation.title"
                  class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  sizes="100vw md:50vw lg:33vw"
                />
                <div class="absolute top-4 right-4 z-10">
                  <UiBadge 
                    v-if="formation.isRncp !== undefined"
                    :variant="formation.isRncp ? 'info' : 'primary'"
                  >
                    {{ formation.isRncp ? 'RNCP' : 'Certificat OXO' }}
                  </UiBadge>
                </div>
              </div>

              <div class="p-6 flex flex-col grow">
                <h2 class="font-display font-bold text-2xl text-foreground mb-2 group-hover:text-oxo-red transition-colors">{{ formation.title }}</h2>
                  
                <div class="flex flex-wrap gap-2 mb-4">
                  <span class="text-xs font-bold px-2 py-1 rounded-sm bg-background border border-oxo-border text-foreground-dim">
                    <i class="fas fa-clock mr-1" aria-hidden="true"></i> {{ formation.duration }}
                  </span>
                  <span class="text-xs font-bold px-2 py-1 rounded-sm bg-background border border-oxo-border text-foreground-dim">
                     <i class="fas fa-graduation-cap mr-1" aria-hidden="true"></i> {{ formation.level }}
                  </span>
                </div>

                <p class="text-foreground-dim text-sm line-clamp-3 mb-6 grow">
                  {{ formation.description }}
                </p>

                <div class="flex flex-wrap gap-2 mt-auto">
                  <span 
                    v-for="tag in formation.tags" 
                    :key="tag"
                    class="text-xs text-oxo-red bg-oxo-red/10 px-2 py-1 rounded-sm"
                  >
                    #{{ tag }}
                  </span>
                </div>
              </div>
            </article>
          </NuxtLink>
        </li>
      </ul>
    </section>


    <AppCTA
      class="mt-24"
      title="Prêt à"
      titleHighlight="TE LANCER ?"
      subtitle="Rejoignez la prochaine promotion et transformez votre passion en métier."
      buttonText="Candidater maintenant"
    >
      <AppDiscoverLinks />
    </AppCTA>
  </div>
</template>

<style scoped>
</style>
